/* public key */
(function() {
	window.nbi = {};
	nbi.publicexponent = "10001";
	nbi.publickey = 'D688BB0FC5DB0598FED0E88F5376F8A4A95DF73C929A622144FBFC8985A0B1D08F8FB580F00FE0DD840AA2E3BA7719331C6B0BCB70C9C8AB54BD80BC341DFA35AD6CC81D5D0B494CC04A13256F989480FA3EB9E58AB5493537CB07F52D79096EAB3C2B9773D48A3D251F43901A678839E07D6E5FE5129A5309718769CB2D3FB74576400A44EA3FC89A26DEDA44092A2E85A85F7996856A1834B049CBB05F7E261E5DEEE99D90A6651A7BF229EC540EA92BAE81C2E476D22D0EE85C6F2EF336675DFE5B4D97F77018221794F640870217AE9091FF1AEB73DCD7DB00B0C73DDC151DC04284B90B15BCAB7894DE0CB80BD8E65E2FE7E68C83E15CAB1C9CD48228C6B77EE65B0D0331B7EBE837242A9E939263B83590A34E22AE9EE8CF58C7A5D04EC735531FC907421DC56A556D9097976E3A0E5C1FE595D7D6D75ECB7ABABC83877E20D0206D93F4655CB077E8588AC4C25211D20D1910B0D56FAC40F65E6F58FF4E4C5087713494525CBB82FEC41F85EDEF9C937DD6E792A4A2DBB6361A28F18BE9DEB21B42846FF7A11D865560B72F3D28759230C01BBDCB44590FAD013AA5945F11DA95DDD3740D9C8C747EC21FC8D5FFF997CB317D38BBCFD8ACCB7DF94B5FF237EBCBA724E373ABA545B10BBCE6B46808C9CB00007A8F90CFB8C893495FDDD4F593090FFC95D62839506B1DD7DBF6B84FFB22B26E7507F14F4F37952B7CC7';
})();
/* public key */
/* barrett */
function BarrettMu(i){this.modulus=biCopy(i),this.k=biHighIndex(this.modulus)+1;var t=new BigInt;t.digits[2*this.k]=1,this.mu=biDivide(t,this.modulus),this.bkplus1=new BigInt,this.bkplus1.digits[this.k+1]=1,this.modulo=BarrettMu_modulo,this.multiplyMod=BarrettMu_multiplyMod,this.powMod=BarrettMu_powMod}function BarrettMu_modulo(i){var t=biDivideByRadixPower(i,this.k-1),u=biMultiply(t,this.mu),o=biDivideByRadixPower(u,this.k+1),s=biModuloByRadixPower(i,this.k+1),d=biMultiply(o,this.modulus),r=biModuloByRadixPower(d,this.k+1),l=biSubtract(s,r);l.isNeg&&(l=biAdd(l,this.bkplus1));for(var h=biCompare(l,this.modulus)>=0;h;)l=biSubtract(l,this.modulus),h=biCompare(l,this.modulus)>=0;return l}function BarrettMu_multiplyMod(i,t){var u=biMultiply(i,t);return this.modulo(u)}function BarrettMu_powMod(i,t){var u=new BigInt;u.digits[0]=1;for(var o=i,s=t;0!=(1&s.digits[0])&&(u=this.multiplyMod(u,o)),0!=(s=biShiftRight(s,1)).digits[0]||0!=biHighIndex(s);)o=this.multiplyMod(o,o);return u}
/* barrett */
/* bigint */
var maxDigits,ZERO_ARRAY,bigZero,bigOne,biRadixBase=2,biRadixBits=16,bitsPerDigit=biRadixBits,biRadix=65536,biHalfRadix=biRadix>>>1,biRadixSquared=biRadix*biRadix,maxDigitVal=biRadix-1,maxInteger=9999999999999998;function setMaxDigits(i){ZERO_ARRAY=new Array(maxDigits=i);for(var t=0;t<ZERO_ARRAY.length;t++)ZERO_ARRAY[t]=0;bigZero=new BigInt,(bigOne=new BigInt).digits[0]=1}setMaxDigits(20);var dpl10=15,lr10=biFromNumber(1e15);function BigInt(i){this.digits="boolean"==typeof i&&1==i?null:ZERO_ARRAY.slice(0),this.isNeg=!1}function biFromDecimal(i){for(var t,r="-"==i.charAt(0),e=r?1:0;e<i.length&&"0"==i.charAt(e);)++e;if(e==i.length)t=new BigInt;else{var g=(i.length-e)%dpl10;for(0==g&&(g=dpl10),t=biFromNumber(Number(i.substr(e,g))),e+=g;e<i.length;)t=biAdd(biMultiply(t,lr10),biFromNumber(Number(i.substr(e,dpl10)))),e+=dpl10;t.isNeg=r}return t}function biCopy(i){var t=new BigInt(!0);return t.digits=i.digits.slice(0),t.isNeg=i.isNeg,t}function biFromNumber(i){var t=new BigInt;t.isNeg=i<0,i=Math.abs(i);for(var r=0;i>0;)t.digits[r++]=i&maxDigitVal,i>>=biRadixBits;return t}function reverseStr(i){for(var t="",r=i.length-1;r>-1;--r)t+=i.charAt(r);return t}var hexatrigesimalToChar=new Array("0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z");function biToString(i,t){var r=new BigInt;r.digits[0]=t;for(var e=biDivideModulo(i,r),g=hexatrigesimalToChar[e[1].digits[0]];1==biCompare(e[0],bigZero);)e=biDivideModulo(e[0],r),digit=e[1].digits[0],g+=hexatrigesimalToChar[e[1].digits[0]];return(i.isNeg?"-":"")+reverseStr(g)}function biToDecimal(i){var t=new BigInt;t.digits[0]=10;for(var r=biDivideModulo(i,t),e=String(r[1].digits[0]);1==biCompare(r[0],bigZero);)r=biDivideModulo(r[0],t),e+=String(r[1].digits[0]);return(i.isNeg?"-":"")+reverseStr(e)}var hexToChar=new Array("0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f");function digitToHex(t){var r="";for(i=0;i<4;++i)r+=hexToChar[15&t],t>>>=4;return reverseStr(r)}function biToHex(i){for(var t="",r=(biHighIndex(i),biHighIndex(i));r>-1;--r)t+=digitToHex(i.digits[r]);return t}function charToHex(i){return i>=48&&i<=57?i-48:i>=65&&i<=90?10+i-65:i>=97&&i<=122?10+i-97:0}function hexToDigit(i){for(var t=0,r=Math.min(i.length,4),e=0;e<r;++e)t<<=4,t|=charToHex(i.charCodeAt(e));return t}function biFromHex(i){for(var t=new BigInt,r=i.length,e=0;r>0;r-=4,++e)t.digits[e]=hexToDigit(i.substr(Math.max(r-4,0),Math.min(r,4)));return t}function biFromString(i,t){var r="-"==i.charAt(0),e=r?1:0,g=new BigInt,n=new BigInt;n.digits[0]=1;for(var s=i.length-1;s>=e;s--){g=biAdd(g,biMultiplyDigit(n,charToHex(i.charCodeAt(s)))),n=biMultiplyDigit(n,t)}return g.isNeg=r,g}function biToBytes(i){for(var t="",r=biHighIndex(i);r>-1;--r)t+=digitToBytes(i.digits[r]);return t}function digitToBytes(i){var t=String.fromCharCode(255&i);return i>>>=8,String.fromCharCode(255&i)+t}function biDump(i){return(i.isNeg?"-":"")+i.digits.join(" ")}function biAdd(i,t){var r;if(i.isNeg!=t.isNeg)t.isNeg=!t.isNeg,r=biSubtract(i,t),t.isNeg=!t.isNeg;else{r=new BigInt;for(var e,g=0,n=0;n<i.digits.length;++n)e=i.digits[n]+t.digits[n]+g,r.digits[n]=65535&e,g=Number(e>=biRadix);r.isNeg=i.isNeg}return r}function biSubtract(i,t){var r;if(i.isNeg!=t.isNeg)t.isNeg=!t.isNeg,r=biAdd(i,t),t.isNeg=!t.isNeg;else{var e,g;r=new BigInt,g=0;for(var n=0;n<i.digits.length;++n)e=i.digits[n]-t.digits[n]+g,r.digits[n]=65535&e,r.digits[n]<0&&(r.digits[n]+=biRadix),g=0-Number(e<0);if(-1==g){g=0;for(n=0;n<i.digits.length;++n)e=0-r.digits[n]+g,r.digits[n]=65535&e,r.digits[n]<0&&(r.digits[n]+=biRadix),g=0-Number(e<0);r.isNeg=!i.isNeg}else r.isNeg=i.isNeg}return r}function biHighIndex(i){for(var t=i.digits.length-1;t>0&&0==i.digits[t];)--t;return t}function biNumBits(i){var t,r=biHighIndex(i),e=i.digits[r],g=(r+1)*bitsPerDigit;for(t=g;t>g-bitsPerDigit&&0==(32768&e);--t)e<<=1;return t}function biMultiply(i,t){for(var r,e,g,n=new BigInt,s=biHighIndex(i),d=biHighIndex(t),a=0;a<=d;++a){for(r=0,g=a,j=0;j<=s;++j,++g)e=n.digits[g]+i.digits[j]*t.digits[a]+r,n.digits[g]=e&maxDigitVal,r=e>>>biRadixBits;n.digits[a+s+1]=r}return n.isNeg=i.isNeg!=t.isNeg,n}function biMultiplyDigit(i,t){var r,e,g;result=new BigInt,r=biHighIndex(i),e=0;for(var n=0;n<=r;++n)g=result.digits[n]+i.digits[n]*t+e,result.digits[n]=g&maxDigitVal,e=g>>>biRadixBits;return result.digits[1+r]=e,result}function arrayCopy(i,t,r,e,g){for(var n=Math.min(t+g,i.length),s=t,d=e;s<n;++s,++d)r[d]=i[s]}var highBitMasks=new Array(0,32768,49152,57344,61440,63488,64512,65024,65280,65408,65472,65504,65520,65528,65532,65534,65535);function biShiftLeft(i,t){var r=Math.floor(t/bitsPerDigit),e=new BigInt;arrayCopy(i.digits,0,e.digits,r,e.digits.length-r);for(var g=t%bitsPerDigit,n=bitsPerDigit-g,s=e.digits.length-1,d=s-1;s>0;--s,--d)e.digits[s]=e.digits[s]<<g&maxDigitVal|(e.digits[d]&highBitMasks[g])>>>n;return e.digits[0]=e.digits[s]<<g&maxDigitVal,e.isNeg=i.isNeg,e}var lowBitMasks=new Array(0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535);function biShiftRight(i,t){var r=Math.floor(t/bitsPerDigit),e=new BigInt;arrayCopy(i.digits,r,e.digits,0,i.digits.length-r);for(var g=t%bitsPerDigit,n=bitsPerDigit-g,s=0,d=s+1;s<e.digits.length-1;++s,++d)e.digits[s]=e.digits[s]>>>g|(e.digits[d]&lowBitMasks[g])<<n;return e.digits[e.digits.length-1]>>>=g,e.isNeg=i.isNeg,e}function biMultiplyByRadixPower(i,t){var r=new BigInt;return arrayCopy(i.digits,0,r.digits,t,r.digits.length-t),r}function biDivideByRadixPower(i,t){var r=new BigInt;return arrayCopy(i.digits,t,r.digits,0,r.digits.length-t),r}function biModuloByRadixPower(i,t){var r=new BigInt;return arrayCopy(i.digits,0,r.digits,0,t),r}function biCompare(i,t){if(i.isNeg!=t.isNeg)return 1-2*Number(i.isNeg);for(var r=i.digits.length-1;r>=0;--r)if(i.digits[r]!=t.digits[r])return i.isNeg?1-2*Number(i.digits[r]>t.digits[r]):1-2*Number(i.digits[r]<t.digits[r]);return 0}function biDivideModulo(i,t){var r,e,g=biNumBits(i),n=biNumBits(t),s=t.isNeg;if(g<n)return i.isNeg?((r=biCopy(bigOne)).isNeg=!t.isNeg,i.isNeg=!1,t.isNeg=!1,e=biSubtract(t,i),i.isNeg=!0,t.isNeg=s):(r=new BigInt,e=biCopy(i)),new Array(r,e);r=new BigInt,e=i;for(var d=Math.ceil(n/bitsPerDigit)-1,a=0;t.digits[d]<biHalfRadix;)t=biShiftLeft(t,1),++a,++n,d=Math.ceil(n/bitsPerDigit)-1;e=biShiftLeft(e,a),g+=a;for(var o=Math.ceil(g/bitsPerDigit)-1,b=biMultiplyByRadixPower(t,o-d);-1!=biCompare(e,b);)++r.digits[o-d],e=biSubtract(e,b);for(var u=o;u>d;--u){var l=u>=e.digits.length?0:e.digits[u],f=u-1>=e.digits.length?0:e.digits[u-1],h=u-2>=e.digits.length?0:e.digits[u-2],x=d>=t.digits.length?0:t.digits[d],v=d-1>=t.digits.length?0:t.digits[d-1];r.digits[u-d-1]=l==x?maxDigitVal:Math.floor((l*biRadix+f)/x);for(var N=r.digits[u-d-1]*(x*biRadix+v),c=l*biRadixSquared+(f*biRadix+h);N>c;)--r.digits[u-d-1],N=r.digits[u-d-1]*(x*biRadix|v),c=l*biRadix*biRadix+(f*biRadix+h);(e=biSubtract(e,biMultiplyDigit(b=biMultiplyByRadixPower(t,u-d-1),r.digits[u-d-1]))).isNeg&&(e=biAdd(e,b),--r.digits[u-d-1])}return e=biShiftRight(e,a),r.isNeg=i.isNeg!=s,i.isNeg&&(r=s?biAdd(r,bigOne):biSubtract(r,bigOne),e=biSubtract(t=biShiftRight(t,a),e)),0==e.digits[0]&&0==biHighIndex(e)&&(e.isNeg=!1),new Array(r,e)}function biDivide(i,t){return biDivideModulo(i,t)[0]}function biModulo(i,t){return biDivideModulo(i,t)[1]}function biMultiplyMod(i,t,r){return biModulo(biMultiply(i,t),r)}function biPow(i,t){for(var r=bigOne,e=i;0!=(1&t)&&(r=biMultiply(r,e)),0!=(t>>=1);)e=biMultiply(e,e);return r}function biPowMod(i,t,r){for(var e=bigOne,g=i,n=t;0!=(1&n.digits[0])&&(e=biMultiplyMod(e,g,r)),0!=(n=biShiftRight(n,1)).digits[0]||0!=biHighIndex(n);)g=biMultiplyMod(g,g,r);return e}
/* bigint */
/* rsa */
var RSAAPP={};function RSAKeyPair(i,n,r,e){this.e=biFromHex(i),this.d=biFromHex(n),this.m=biFromHex(r),this.chunkSize="number"!=typeof e?2*biHighIndex(this.m):e/8,this.radix=16,this.barrett=new BarrettMu(this.m)}function encryptedString(i,n,r,e){var t,o,d,h,a,g,S,c,P,u=new Array,A=n.length,s="";for(h="string"==typeof r?r==RSAAPP.NoPadding?1:r==RSAAPP.PKCS1Padding?2:0:0,a="string"==typeof e&&e==RSAAPP.RawEncoding?1:0,1==h?A>i.chunkSize&&(A=i.chunkSize):2==h&&A>i.chunkSize-11&&(A=i.chunkSize-11),t=0,o=2==h?A-1:i.chunkSize-1;t<A;)h?u[o]=n.charCodeAt(t):u[t]=n.charCodeAt(t),t++,o--;for(1==h&&(t=0),o=i.chunkSize-A%i.chunkSize;o>0;){if(2==h){for(g=Math.floor(256*Math.random());!g;)g=Math.floor(256*Math.random());u[t]=g}else u[t]=0;t++,o--}for(2==h&&(u[A]=0,u[i.chunkSize-2]=2,u[i.chunkSize-1]=0),S=u.length,t=0;t<S;t+=i.chunkSize){for(c=new BigInt,o=0,d=t;d<t+i.chunkSize;++o)c.digits[o]=u[d++],c.digits[o]+=u[d++]<<8;P=i.barrett.powMod(c,i.e),s+=1==a?biToBytes(P):16==i.radix?biToHex(P):biToString(P,i.radix)}return s}function decryptedString(i,n){var r,e,t,o,d=n.split(" "),h="";for(e=0;e<d.length;++e)for(o=16==i.radix?biFromHex(d[e]):biFromString(d[e],i.radix),r=i.barrett.powMod(o,i.d),t=0;t<=biHighIndex(r);++t)h+=String.fromCharCode(255&r.digits[t],r.digits[t]>>8);return 0==h.charCodeAt(h.length-1)&&(h=h.substring(0,h.length-1)),h}RSAAPP.NoPadding="NoPadding",RSAAPP.PKCS1Padding="PKCS1Padding",RSAAPP.RawEncoding="RawEncoding",RSAAPP.NumericEncoding="NumericEncoding";
/* rsa */


(function() {
	var current_selection = '_null';
	var shopurl = window.Shopify.shop;
    var valid_states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NM', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

	var loadScript = function(url, callback)
	{
		var script = document.createElement("script");
		script.type = "text/javascript";
		if (script.readyState)
		{ 
			script.onreadystatechange = function()
			{
				if (script.readyState == "loaded" || script.readyState == "complete")
				{
					script.onreadystatechange = null;
					callback();
				}
			};
		}
		else
		{
			script.onload = function()
			{
				callback();
			};
		}
		script.src = url;
		document.getElementsByTagName("head")[0].appendChild(script);
	};

	var preLoad = function ()
	{
						init();

	}

	var init = function($ = window.$)
	{
		var root = typeof self === 'object' && self.self === self && self ||
			typeof global === 'object' && global.global === global && global ||
			this;
		var JSJExpertLTA = function (obj) {
			if (obj instanceof JSJExpertLTA) return obj;
			if (!(this instanceof JSJExpertLTA)) return new JSJExpertLTA(obj);
			};
		root.JSJExpertLTA = JSJExpertLTA;  
		JSJExpertLTA.queue = {change: [], add: []};
		var donothing = function (result)
		{
		};

		var setCookie = function (name,value,days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "")  + expires + "; path=/";
			return name + ' set';
		};

		var getCookie = function (name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		};

		function bodyLoad()
		{
			window.setMaxDigits(10000);
			window.RSAkey = new RSAKeyPair(
				window.nbi.publicexponent,
				window.nbi.publicexponent,
				window.nbi.publickey,
				4096
				);
		}

/**
* Secure Hash Algorithm (SHA1)
* http://www.webtoolkit.info/
**/
		function SHA1(msg) {
			function rotate_left(n,s) {
				var t4 = ( n<<s ) | (n>>>(32-s));
				return t4;
			};
			function lsb_hex(val) {
				var str='';
				var i;
				var vh;
				var vl;
				for( i=0; i<=6; i+=2 ) {
					vh = (val>>>(i*4+4))&0x0f;
					vl = (val>>>(i*4))&0x0f;
					str += vh.toString(16) + vl.toString(16);
				}
				return str;
			};
			function cvt_hex(val) {
				var str='';
				var i;
				var v;
				for( i=7; i>=0; i-- ) {
					v = (val>>>(i*4))&0x0f;
					str += v.toString(16);
				}
				return str;
			};
			function Utf8Encode(string) {
				string = string.replace(/\r\n/g,'\n');
				var utftext = '';
				for (var n = 0; n < string.length; n++) {
					var c = string.charCodeAt(n);
					if (c < 128) {
						utftext += String.fromCharCode(c);
					}
					else if((c > 127) && (c < 2048)) {
						utftext += String.fromCharCode((c >> 6) | 192);
						utftext += String.fromCharCode((c & 63) | 128);
					}
					else {
						utftext += String.fromCharCode((c >> 12) | 224);
						utftext += String.fromCharCode(((c >> 6) & 63) | 128);
						utftext += String.fromCharCode((c & 63) | 128);
					}
				}
				return utftext;
			};
			var blockstart;
			var i, j;
			var W = new Array(80);
			var H0 = 0x67452301;
			var H1 = 0xEFCDAB89;
			var H2 = 0x98BADCFE;
			var H3 = 0x10325476;
			var H4 = 0xC3D2E1F0;
			var A, B, C, D, E;
			var temp;
			msg = Utf8Encode(msg);
			var msg_len = msg.length;
			var word_array = new Array();
			for( i=0; i<msg_len-3; i+=4 ) {
				j = msg.charCodeAt(i)<<24 | msg.charCodeAt(i+1)<<16 |
				msg.charCodeAt(i+2)<<8 | msg.charCodeAt(i+3);
				word_array.push( j );
			}
			switch( msg_len % 4 ) {
				case 0:
					i = 0x080000000;
					break;
				case 1:
					i = msg.charCodeAt(msg_len-1)<<24 | 0x0800000;
					break;
				case 2:
					i = msg.charCodeAt(msg_len-2)<<24 | msg.charCodeAt(msg_len-1)<<16 | 0x08000;
					break;
				case 3:
					i = msg.charCodeAt(msg_len-3)<<24 | msg.charCodeAt(msg_len-2)<<16 | msg.charCodeAt(msg_len-1)<<8 | 0x80;
					break;
			}
			word_array.push( i );
			while( (word_array.length % 16) != 14 ) word_array.push( 0 );
			word_array.push( msg_len>>>29 );
			word_array.push( (msg_len<<3)&0x0ffffffff );
			for ( blockstart=0; blockstart<word_array.length; blockstart+=16 ) {
				for( i=0; i<16; i++ ) W[i] = word_array[blockstart+i];
				for( i=16; i<=79; i++ ) W[i] = rotate_left(W[i-3] ^ W[i-8] ^ W[i-14] ^ W[i-16], 1);
				A = H0;
				B = H1;
				C = H2;
				D = H3;
				E = H4;
				for( i= 0; i<=19; i++ ) {
					temp = (rotate_left(A,5) + ((B&C) | (~B&D)) + E + W[i] + 0x5A827999) & 0x0ffffffff;
					E = D;
					D = C;
					C = rotate_left(B,30);
					B = A;
					A = temp;
				}
				for( i=20; i<=39; i++ ) {
					temp = (rotate_left(A,5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff;
					E = D;
					D = C;
					C = rotate_left(B,30);
					B = A;
					A = temp;
				}
				for( i=40; i<=59; i++ ) {
					temp = (rotate_left(A,5) + ((B&C) | (B&D) | (C&D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff;
					E = D;
					D = C;
					C = rotate_left(B,30);
					B = A;
					A = temp;
				}
				for( i=60; i<=79; i++ ) {
					temp = (rotate_left(A,5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff;
					E = D;
					D = C;
					C = rotate_left(B,30);
					B = A;
					A = temp;
				}
				H0 = (H0 + A) & 0x0ffffffff;
				H1 = (H1 + B) & 0x0ffffffff;
				H2 = (H2 + C) & 0x0ffffffff;
				H3 = (H3 + D) & 0x0ffffffff;
				H4 = (H4 + E) & 0x0ffffffff;
			}
			var temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

			return temp.toLowerCase();
		}
		
		var ajaxForm = function(datastring, callback = donothing, error = donothing)
		{
			$.ajax(
			{
				url:"https://app.nbihealth.com/api/",
				type: "POST",
				data: datastring,
				dataType: "JSON",
				success: function(result)
				{
					if(result.success)
					{
						callback(result.success);
					}
					else if(result.error)
					{
						console.log(result);
						error(result.error);
					}
				},
				error: function(result)
				{
					console.log(result);
					error(result.error);
				},
			});
		}

        var isValidDate = function (dateString)
        {
        // First check for the pattern
        if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
          return false;

        // Parse the date parts to integers
        var parts = dateString.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month == 0 || month > 12)
          return false;

        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
          monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
        };
        
        var LTAResultOrder = function (order_id, lta_order_id)
		{
			datastring = {data: {order_id: order_id, lta_order_id: lta_order_id}, action:"LTAResultOrder", shop: shopurl};
			ajaxForm(datastring, LTAResultOrder_after);
		};

		var LTAResultOrder_after = function (result)
		{
			//console.log('LTAResultOrder_after');
			//console.log(result);
			if(result.ResPDFMime)
			{
				createBlob(result.OrderId, result.OrderStatus, result.ResPDFMime, result.consent);
			}
			else
			{
				createBlob(result.OrderId, result.OrderStatus, result.ReqPDFMime, result.consent);
			}
		};

		JSJExpertLTA.LTAResultOrder = function (order_id, lta_order_id)
		{
			LTAResultOrder(order_id, lta_order_id);
		};
		
		var LTAGetPSC = function (zip)
		{
			datastring = {data: zip, action:"LTAGetPSC", shop: shopurl};
			ajaxForm(datastring, LTAGetPSC_after, LTAGetPSC_error);
		};
		
		var LTAGetPSC_after = function (result)
		{
			$('#psc_error').hide();
			$('#psc_locations').find('tr').remove();
			var distance = Number($('#LTALookupDistance').val());
			var hasresult = false;
			for(x in result)
			{
				if(result[x] && (result[x].distance <= distance))
				{
					thisloc = "<tr><td>"+Number(result[x].distance).toFixed(2)+" mi</td><td>"+result[x].name+"<br />"+result[x].address+"<br />"+result[x].city+", "+result[x].state+", "+result[x].zip+"</td><td>"+result[x].telephone+"</td><td>"+result[x].hours+"</td></tr>";
					$('#psc_locations').append(thisloc);
					hasresult = true;
				}
				if(x = result.length -1)
				{
					if(hasresult)
					{
						$('#psc').show();
					}
					else
					{
						LTAGetPSC_error();
					}
				}
			}
		};
		
		var LTAGetPSC_error = function ()
		{
			$('#psc').hide();
			$('#psc_error').show();
			$('#psc_locations').find('tr').remove();
		};

		var ajaxQueue = function(reload = false)
		{
			if(JSJExpertLTA.queue.change.length)
			{
				var request = JSJExpertLTA.queue.change.shift();
				$.post('/cart/change.js', request, ajaxQueue, 'json');
			}
			else if(JSJExpertLTA.queue.add.length)
			{
				var request = JSJExpertLTA.queue.add.shift();
				$.post('/cart/add.js', request, ajaxQueue(true), 'json');
			}
			else
			{
				setTimeout(function(){
					window.location.reload();
				}, 250);
			}
		}

		var createBlob = function (order_id, status, blobdata, consentdata = null)
		{
			var patient = $('.lta_status[data-id='+order_id+']').attr('id').replace('patient_', '').replace(/_/g, ' ').toUpperCase();
			var message = '<td>'+patient+'</td>';
			if(consentdata)
			{
				message += '<td class="consent"><span>Consent: </span><span id="'+order_id+'_consent_print"></span> or <span id="'+order_id+'_consent_download"></span></td>';
			}
			
			if(status == 'RESULTED')
			{
				message += "<td><span>Results: </span>";
			}
			else
			{
				message += "<td><span>Requisition form: </span>";
			}
			message += '<span id="'+order_id+'_print"></span> or <span id="'+order_id+'_download"></span></td>';
			var blobdecoded = b64toBlob(blobdata, 'application/pdf');
			var bloburl = window.URL.createObjectURL(blobdecoded);
			var span = $('.lta_status[data-id='+order_id+']');
			var d = window.document.createElement("a");
			var p = window.document.createElement("a");
			$(span).html(message);
			d.href = bloburl;
			d.download = order_id+".pdf";
			d.innerHTML = "Download";
			p.href = 'javascript:void(0);';
			p.onclick = function() {
				var printwin = window.open(bloburl, "_blank");
				$(printwin).load(function(){
					printwin.print();
				});
			};
			p.innerHTML = "Print";
			$('#'+order_id+'_print').append(p);
			$('#'+order_id+'_download').append(d);
			if(consentdata)
			{
				var consentdecoded = b64toBlob(consentdata, 'application/pdf');
				var consenturl = window.URL.createObjectURL(consentdecoded);
				var cd = window.document.createElement("a");
				var cp = window.document.createElement("a");
				cd.href = consenturl;
				cd.download = order_id+"_consent.pdf";
				cd.innerHTML = "Download";
				cp.href = 'javascript:void(0);';
				cp.onclick = function() {
					var printwin = window.open(consenturl, "_blank");
					$(printwin).load(function(){
						printwin.print();
					});
				};
				cp.innerHTML = "Print";
				$('#'+order_id+'_consent_print').append(cp);
				$('#'+order_id+'_consent_download').append(cd);
			}
			$('span#test_req_loading').remove();
			$('#document_table').show();
		};

		var createInvoiceBlob = function (order_id, blobdata)
		{
			//console.log('createInvoiceBlob');
			var blobdecoded = b64toBlob(blobdata, 'application/pdf');
			var bloburl = window.URL.createObjectURL(blobdecoded);
			var d = window.document.getElementById("receiptDownload");
			var p = window.document.getElementById("receiptPrint");
			var div = window.document.getElementById("invoice_actions");
			d.href = bloburl;
			d.download = order_id+".pdf";
			p.href = 'javascript:void(0);';
			p.onclick = function() {
				var printwin = window.open(bloburl, "_blank");
				$(printwin).load(function(){
					printwin.print();
				});
			};
			window.document.getElementById('invoice_loading').style.display = "none";
			div.classList.add('active');
		};

		const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
			const byteCharacters = atob(b64Data);
			const byteArrays = [];
			for (let offset = 0; offset < byteCharacters.length; offset += sliceSize)
			{
				const slice = byteCharacters.slice(offset, offset + sliceSize);

				const byteNumbers = new Array(slice.length);
				for (let i = 0; i < slice.length; i++)
				{
					byteNumbers[i] = slice.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}
			const blob = new Blob(byteArrays, {type: contentType});
			return blob;
		}
		
		var validatePatientForm = function()
		{
			$('.LTAFormInput').each(function()
			{
				validateInput(this)
			});
          waitForTrue($('.LTAFormInput[data-status=valid]').length == $('.LTAFormInput').length, function() {
            $('#LTAFormSave').prop('disabled', false);
          },function() {
            $('#LTAFormSave').prop('disabled', true);
          });
		}
 


		$(document).ready(function()
		{
			var returnurl = getCookie('nbi_return_url');
			var currenturl = window.location.pathname;
			if(currenturl == '/account/login')
			{
				$("#redirect_url").val(returnurl);
				$.getJSON('/cart.js', function(result) {
					var items = result.items;
					for(x in items)
					{
						if(items[x].product_type == nbi_test)
						{
							$('#test_login_message').show();
						}
					}
				});				
			}
          	else if(currenturl == '/account/register')
            {
				$("#redirect_url").val(returnurl);
            }
			else
			{
				setCookie('nbi_return_url', currenturl, 1);
			}

			$('.LTAFormInput').each(function()
			{
				validateInput(this, true)
				if($('.LTAFormInput').length !== $('.LTAFormInput[data-status=valid]').length)
				{
					$('#AddFormToCartText').html("{{ 'products.product.test_add_to_cart_first' | t }}");
				}
			});    
			if($('#LTATestFormZip').val())
			{
				validateZip($('#LTATestFormZip').val());
			}
			if($('#LTALookupZip').val())
			{
				validateZip($('#LTALookupZip').val());
			}
            var date = new Date(); 
			var today_str = date.toISOString().slice(0,10);
			$('#LTATestFormDate').val(today_str);
			$('#LTATestFormDate').attr('data-status', 'valid');
			var LTAFormCount = $('.LTAFormInput').length;
			var LTAFormValidCount = $('.LTAFormInput[data-status=valid]').length;
			$('#LTATestFormZip').on('blur', function (){
				validateZip($(this).val());
			});
			$('#LTALookupZip').on('blur', function (){
				validateZip($(this).val());
			});
			$('#LTALookupZip').on('change', function (){
				validateZip($(this).val());
			});
			$('#LTALookupDistance').on('change', function (){
              	$(this).attr('data-status', 'valid');
				validateZip($(this).val());
			});
			$('.LTAFormInput').on('blur', function() {
				validateInput(this);
				waitForTrue($('.LTAFormInput[data-status=valid]').length == $('.LTAFormInput').length, function() {
					$('#LTAFormSave').prop('disabled', false);
				},function() {
					$('#LTAFormSave').prop('disabled', true);
				});
			});
			$('.LTAFormInput').on('change', function() {
				validateInput(this);
				waitForTrue($('.LTAFormInput[data-status=valid]').length == $('.LTAFormInput').length, function() {
					$('#LTAFormSave').prop('disabled', false);
				},function() {
					$('#LTAFormSave').prop('disabled', true);
				});
			});
			$('#LTAFormCancel').on('click', function(e) {
				e.preventDefault();
				$('#patient_add_overlay').hide();
				$('#patient_delete').hide();
				$('#patient_add_spinner').show();
				//$('select.patient_select').val(current_selection);
			});
			$('#LTAFormSave').on('click', function(e) {
				e.preventDefault();
				savePatient(cmdEncryptClick());
				$('#patient_add_overlay').hide();
				$('#patient_delete').hide();
				$('#patient_add_spinner').show();
			});
			$('#LTALookupSearch').on('click', function(e) {
				e.preventDefault();
				if($('#LTALookupZip').val())
				{
					$('#zip_search_overlay').show();
					LTAGetPSC($('#LTALookupZip').val());
				}
			});
			getPatientIDs();
			var all_patients = false;
			$('select.patient_select').on('change', function()
			{
                current_selection = '_null';
				if($(this).val() == '_add')
				{
					$(this).val('_null');
					$('#patient_add_overlay').show();
					$('#patient_add_spinner').hide();
				}
				else
				{
					var itemkey = $(this).attr('data-id');
					var current_selection = $(this).val();
					$('.patient_icon[data-id="'+itemkey+'"]').each(function(){
						$(this).attr('data-p', current_selection);
					});
					$.getJSON('/cart.js', function(result) {
						var items = result.items;
						for(x in items)
						{
							if(items[x].key == itemkey)
							{
								JSJExpertLTA.queue.change.push({ id: items[x].key, properties: { '_patient_id' : current_selection,}, quantity: 1 });
								if(Number($('.cart__quantity-selector[id="updates_'+items[x].key+'"]').val()) > 1)
								{
									JSJExpertLTA.queue.add.push({ id: items[x].id, quantity: Number($('.cart__quantity-selector[id="updates_'+items[x].key+'"]').val())-1 });
								}

/*								$.post('/cart/change.js', { id: items[x].key, properties: { '_patient_id' : current_selection,}, quantity: 1 }, function(result) {
									if(Number($('.cart__quantity-selector[id="updates_'+items[x].key+'"]').val()) > 1)
									{
										$.post('/cart/add.js', { id: items[x].id, quantity: Number($('.cart__quantity-selector[id="updates_'+items[x].key+'"]').val())-1 }, function(result) {
											window.location.reload();
										}, 'json');
									}
								}, 'json');*/
							}
						}
						ajaxQueue();
					});
				}

			});
			$('select.patient_select_account').on('change', function()
			{
                current_selection = '_null';
				if($(this).val() == '_add')
				{
					$(this).val('_null');
					$('.patient_edit').attr('data-p', '').hide();
					$('#patient_add_overlay').show();
					$('#patient_add_spinner').hide();
				}
				else
				{
					$('.patient_edit').attr('data-p', $(this).val()).show();
                }

			});
			$('select.patient_select').on('click', function() {
				if($(this).val())
				{
					if($(this).val().charAt(0) != '_')
					{
						current_selection = $(this).val();
					}
				}
			});
			$('.patient_edit').on('click', function()
			{
				if(patient = $(this).attr('data-p'))
				{
					getPatient(atob(patient));
					$('#patient_add_overlay').show();
					$('#patient_delete').show();
					$('#LTADeleteSave').attr('data-p', $(this).attr('data-p'));
				}
			});
			$('.patient_remove').on('click', function()
			{
				$('#patient_inner_overlay').show();
			});
			$('#LTADeleteCancel').on('click', function(e)
			{
				e.preventDefault();
				$('#patient_inner_overlay').hide();
			});
			$('#LTADeleteSave').on('click', function(e)
			{
				e.preventDefault();
				deletePatient(atob($(this).attr('data-p')));
			});
           $('#LTATestFormTOSConsentLink').on('click', function() {
              var consentdate = new Date(Date.now());
              $('#LTATestFormTOSConsentDate').val(consentdate)
              $('#LTATestFormTOSConsentFormDate').html(consentdate);
              $('#LTATestFormTOSConsentDateDisplay').html('Consented: '+consentdate);
              $('#LTATestFormTOSConsentFormFirstName').html($('#LTATestFormFirstName').val());
              $('#LTATestFormTOSConsentFormLastName').html($('#LTATestFormLastName').val());
              $('#patient_consent_overlay').show();
              $("#patient_consent_overlay").animate({ scrollTop: $("#patient_consent_overlay").scrollTop()+$('#patient_consent_agreement').offset().top-1000000 }, { duration: '0.01s', easing: 'swing' });
            });
            $('#LTATestFormTOSConsent').on('change', function(e) {
              e.preventDefault();
              if($('#LTATestFormTOSConsent').prop('checked') == true)
              {
                var consentdate = new Date(Date.now());
                $('#LTATestFormTOSConsentDate').val(consentdate)
				$('#LTATestFormTOSConsentFormDate').html(consentdate);
                $('#LTATestFormTOSConsentDateDisplay').html('Consented: '+consentdate);
                $('#LTATestFormTOSConsentFormFirstName').html($('#LTATestFormFirstName').val());
                $('#LTATestFormTOSConsentFormLastName').html($('#LTATestFormLastName').val());
                $('#patient_consent_overlay').show();
                $("#patient_consent_overlay").animate({ scrollTop: $("#patient_consent_overlay").scrollTop()+$('#patient_consent_agreement').offset().top-1000000 }, { duration: '0.01s', easing: 'swing' });
              }
              else
              {
                $('#LTATestFormTOSConsentDate').val('').prop('disabled', true);
                $('#LTATestFormTOSConsentFormDate').html('');
                $('#LTATestFormTOSConsentDateDisplay').html('');
                $('#LTATestFormTOSConsentFormFirstName').html('');
                $('#LTATestFormTOSConsentFormLastName').html('');
                $('#LTATestFormTOSConsent').prop('checked', false);
              }            
            });
            $('#LTAConsentDecline').on('click', function() {
              $('#LTATestFormTOSConsentDate').val('').prop('disabled', true);
              $('#LTATestFormTOSConsentFormDate').html('');
              $('#LTATestFormTOSConsentDateDisplay').html('');
              $('#LTATestFormTOSConsentFormFirstName').html('');
              $('#LTATestFormTOSConsentFormLastName').html('');
              $('#LTATestFormTOSConsent').prop('checked', false);
              $('#patient_consent_overlay').hide();
            });
            $('#LTAConsentAccept').on('click', function() {
              $('#LTATestFormTOSConsentDate').prop('disabled', false);
              $('#LTATestFormTOSConsent').prop('checked', true);
              $('#patient_consent_overlay').hide();
            });
                 		
			bodyLoad();
			if(typeof Shopify.Checkout !== 'undefined')
			{
				if((Shopify.Checkout.isOrderStatusPage || window.Shopify.Checkout.step == 'thank_you' ) && Shopify.checkout.order_id)
				{
					pollForResults(Shopify.checkout.order_id);
					createPDFInvoice(Shopify.checkout.order_id);
				}
			}
		});

		function savePatient(patient) {
			patient.customer = window.ShopifyAnalytics.meta.page.customerId;
			datastring = {data: patient, action:"savePatient", shop: shopurl};
			ajaxForm(datastring, function(){window.location.reload();}); 
		}
		
		function deletePatient(patient) {
			customer = window.ShopifyAnalytics.meta.page.customerId;
			datastring = {data: {customer: customer, patient: patient}, action:"deletePatient", shop: shopurl};
			ajaxForm(datastring, function(){
				$.getJSON('/cart.js', function(result) {
					var items = result.items;
					//console.log(items);
					for(x in items)
					{
						if(items[x].product_type == nbi_test && items[x].properties)
						{
							if(typeof items[x].properties._patient_id != 'undefined' && items[x].properties._patient_id == patient)
							{
								JSJExpertLTA.queue.change.push({ id: items[x].key, properties: {'_patient_id' : null}, quantity: items[x].quantity });
							}
						}
					}
					ajaxQueue();
				});
			}); 
		}

		function getPatientIDs()
		{
			customer = window.ShopifyAnalytics.meta.page.customerId;
			datastring = {data: {customer: customer}, action:"getPatientIDs", shop: shopurl};
			ajaxForm(datastring, getPatientIDs_after); 
		}

		function getPatientIDs_after(patients)
		{
//			patients = JSON.parse(patients);
			console.log(patients);
			var cart =
			fetch('/cart.json').then((resp) => resp.json()).then(function(cart){
				for(x in patients)
				{
					console.log(patients[x]);
					patient = patients[x].toUpperCase().replace("_", " ");
					$('.patient_select').each(async function(){
						$(this).attr('data-valid', 'false');
						key =  cart.items.findIndex(x => x.key === $(this).attr('data-id'));
						selected = '';
						if(key !== -1 && ('properties' in cart.items[key])){
							if(cart.items[key].properties !== null && cart.items[key].properties.hasOwnProperty("_patient_id")) {
								$(this).attr('data-valid', 'true');
								if(cart.items[key].properties['_patient_id'] == btoa(patients[x]))
								{
									selected = 'selected';
									$(this).parent().siblings('.patient_edit').attr('data-p', cart.items[key].properties['_patient_id']).removeClass('hidden');
								}
							}
						}
						$(this).children('option').first().after('<option value="'+btoa(patients[x])+'" '+selected+'>'+patient+'</option>');
					});
					//$('.patient_select>option').first().after('<option value="'+btoa(patients[x])+'">'+patient+'</option>');
				}
				
			}).then($('.patient_select').each(function(){
				setTimeout(function(){
					if($('.patient_select[data-valid=true]').length == $('.patient_select').length){
						console.log('Checkoutable!');
						 $('button.btn[type="submit"][name="checkout"]').prop('disabled', false);
					}
				},500);
			}));
		}

		function getPatient(patient)
		{
			customer = window.ShopifyAnalytics.meta.page.customerId;
			datastring = {data: {customer: customer, patient: patient}, action:"getPatient", shop: shopurl};
			ajaxForm(datastring, getPatient_after); 
		}

		function getPatient_after(patient)
		{
			patient = JSON.parse(patient);
			$('#LTATestFormFirstName').val(patient.first_name).attr('data-status', 'valid');
			$('#LTATestFormLastName').val(patient.last_name).attr('data-status', 'valid');
			$('#LTATestFormMobile').val(patient.mobile).attr('data-status', 'valid');
			$('#LTATestFormEmailAddress').val(patient.email_address).attr('data-status', 'valid');
			$('#LTATestFormAddress').val(patient.address).attr('data-status', 'valid');
			$('#LTATestFormCity').val(patient.city).attr('data-status', 'valid');
			$('#LTATestFormState').val(patient.state).attr('data-status', 'valid');
			$('#LTATestFormZip').val(patient.zip).attr('data-status', 'valid');
			$('#LTATestFormGender').val(patient.gender).attr('data-status', 'valid');
			$('#LTATestFormDOB').val(patient.dob).attr('data-status', 'valid');
            datearray = patient.dob.split("-");
            newdate =  datearray[1]+'/'+datearray[2]+'/'+datearray[0];
			$('#LTATestFormDOB_edit').val(newdate);
			if(patient.email_notification)
			{
				$('#LTATestFormNotificationByEmail').prop('checked', true).attr('data-status', 'valid');
			}
			else
			{
				$('#LTATestFormNotificationByEmail').prop('checked', false).attr('data-status', 'valid');
			}
			if(patient.tos_consent && Date.parse(patient.tos_consent_date) >= window.consent_form_date)
			{
              $('#LTATestFormTOSConsentDate').val(patient.tos_consent_date).attr('data-status', 'valid');
              $('#LTATestFormTOSConsentDateDisplay').html('Consented: '+patient.tos_consent_date);
              $('#LTATestFormTOSConsent').prop('checked', true).attr('data-status', 'valid');
			}
			else
			{
				$('#LTATestFormTOSConsent').prop('checked', false).attr('data-status', 'invalid');
			}
			$('#patient_add_spinner').hide();
			$('#LTAFormSave').prop('disabled', false);
		}
		
		function ajaxPromise(datastring)
		{
			var resultPromise = new Promise(function(resolve, reject)
			{
				$.ajax(
				{
					url:"https://app.nbihealth.com/api/",
					type: "POST",
					data: datastring,
					dataType: "JSON",
					success: function(result)
					{
						//console.log(result);
						if(result.success)
						{
							//console.log('resolving');
							resolve(result.success);
						}
						else
						{
							//console.log('rejecting');
							reject();
						}
					},
					error: function(result)
					{
						reject();
					},
				});
			});
			return resultPromise;
		}
		
		function pollForResults(order_id)
		{
			datastring = {data: order_id, action:"pollForResults", shop: shopurl};
			ajaxPromise(datastring).then(displayCheckoutResults, function()
			{
				setTimeout(function()
				{
					pollForResults(order_id)
				},500)
			});
		}
		
		JSJExpertLTA.pollForResults = function (order_id)
		{
			createPDFInvoice(order_id);
			pollForResults(order_id);
		}
		
		function displayCheckoutResults(data)
		{
			for(x in data.attributes)
			{
				if(data.attributes[x].name.includes("patient_") && (data.attributes[x].value != ""))
				{
					$('tr#'+data.attributes[x].name).attr('data-id', data.attributes[x].value);
					LTAResultOrder(data.order_id, atob(data.attributes[x].value));
				}
			}
		}

		function createPDFInvoice(order_id)
		{
			datastring = {data: order_id, action:"createPDFInvoice", shop: shopurl};
			//console.log('createPDFInvoice');
			ajaxPromise(datastring).then(displayPDFInvoice, donothing);
		}
		
		JSJExpertLTA.createPDFInvoice = function (order_id)
		{
			createPDFInvoice(order_id);
		}
		
		function displayPDFInvoice(data)
		{
			//console.log(data);
			//console.log('displayPDFInvoice');
			createInvoiceBlob(data[0].order_id, data[0].pdf);
		}

		function waitForTrue(thingie, callback, fallback = function() {})
		{
			var iterations = 0;
			var timer = setInterval(function()
			{
				iterations++;
				if(thingie != false){
					clearInterval(timer);
					callback();
				}
				if(iterations >= 5)
				{
					clearInterval(timer);
					fallback();
				} 
			}, 100);
		}
		
		function calculateAge(dob)
		{
			var ageDifMs = Date.now() - dob.getTime();
			var ageDate = new Date(ageDifMs); // miliseconds from epoch
			if(Math.abs(ageDate.getUTCFullYear() - 1970) >= 18)
			{
				return true
			}
			else
			{
				return false;
			}
		}    

		function cmdEncryptClick()
		{
			var formdata = JSON.stringify(getFormData($('#LTAForm')));
			var ciphertext = encryptedString(window.RSAkey, formdata,
				RSAAPP.PKCS1Padding, RSAAPP.RawEncoding);
			var patient_id = $('#LTATestFormFirstName').val().toLowerCase()+"_"+$('#LTATestFormLastName').val().toLowerCase();
            var patient =  { patient: {id:patient_id, phi: window.btoa(ciphertext), consent: $('#LTATestFormTOSConsentDate').val()} };
			return patient;
		}

		function getFormData($form)
		{
			var unindexed_array = $form.serializeArray();
			var indexed_array = {};
			$.map(unindexed_array, function(n, i){
				indexed_array[n['name']] = n['value'];
			});
			return indexed_array;
		}

		function validateZip(zip)
		{
			var url = 'https://api.zippopotam.us/us/' + zip;
			var xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function ()
			{
				if (xhr.readyState == 4)
				{
					var result = xhr.responseText;
					var zippo = JSON.parse(result);
					if(zippo.places && zippo.places.length > 0)
					{
						if(zippo.places[0]['place name'])
						{
							$('#LTATestFormCity').val(zippo.places[0]['place name']);
							$('#LTATestFormCity').removeClass('error');
							$('div[data-input=LTATestFormCity]').addClass('hide');
							$('#LTATestFormCity').attr('data-status', 'valid');
						}
						if(zippo.places[0]['state abbreviation'])
						{
                            if(!valid_states.includes(zippo.places[0]['state abbreviation']))
                            {
                                $('#LTATestFormState').addClass('error');
                                $('div[data-input=LTATestFormState][data-type=invalid]').removeClass('hide');
                            }
                            else
                            {
								$('#LTATestFormState').removeClass('error');
                                $('#LTATestFormState').attr('data-status', 'valid');
                                $('div[data-input=LTATestFormState]').addClass('hide');
                            }
							$('#LTATestFormState').val(zippo.places[0]['state abbreviation']);
						}
						$('#LTATestFormZip').attr('data-status', 'valid');
						$('#LTATestFormZip').removeClass('error');
						$('div[data-input=LTATestFormZip][data-type=invalid]').addClass('hide');
                        if($('#LTALookupDistance').attr('data-status') == 'valid' && $('#LTALookupZip').attr('data-status') == 'valid')
                        {
						  $('#LTALookupSearch').prop('disabled', false);
                        }
						waitForTrue($('.LTAFormInput[data-status=valid]').length == $('.LTAFormInput').length, function() {
							$('#AddFormToCartText').html("{{ 'products.product.test_add_to_cart_second' | t }}");
						});
					}
					else
					{
                        if($('#LTALookupDistance').attr('data-status') == 'valid' && $('#LTALookupZip').attr('data-status') == 'valid')
                        {
						  $('#LTALookupSearch').prop('disabled', false);
                        }
						$('#LTATestFormZip').addClass('error');
						$('div[data-input=LTATestFormZip][data-type=invalid]').removeClass('hide');
						$('#LTATestFormZip').attr('data-status', 'invalid');
						$('#AddFormToCartText').html("{{ 'products.product.test_add_to_cart_first' | t }}");
					}
				}
			}
			xhr.open('GET', url, true);
			xhr.send(null);
		};

		function validateInput(input, silent = false)
		{
			$(input).removeClass('error');
			$('div[data-input='+$(input).attr('id')+']').addClass('hide');
			if($(input).attr('id') == 'LTATestFormTOSConsent' )
			{
				if($(input).prop('checked') == true)
				{
					$(input).removeClass('error');
					$(input).attr('data-status', 'valid');
				}
				else
				{
					$(input).addClass('error');
					$(input).attr('data-status', 'invalid');
				}
			}
			else if($(input).attr('id') == 'LTATestFormNotificationByEmail' )
			{
				$(input).removeClass('error');
				$(input).attr('data-status', 'valid');
			}
			else if((!$(input).val() || $(input).val() == ""))
			{
				if(!silent)
				{
					$(input).addClass('error');
					$('div[data-input='+$(input).attr('id')+'][data-type=blank]').removeClass('hide');
				}
				$(input).attr('data-status', 'invalid');
				return false;
			}
			else
			{
				switch(true)
				{
					case ($(input).attr('id') == 'LTATestFormMobile'):
						var reg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
						if (!reg.test($(input).val()))
						{
							if(!silent)
							{
								$(input).addClass('error');
								$('div[data-input='+$(input).attr('id')+'][data-type=invalid]').removeClass('hide');
							}
							$(input).attr('data-status', 'invalid');
						}
						else
						{
							$(input).removeClass('error');
							$('div[data-input='+$(input).attr('id')+'][data-type=invalid]').addClass('hide');
							var mobile = $(input).val();
							$(input).val(mobile.replace(reg, "$1$2$3"));
							$(input).attr('data-status', 'valid');
						}
						return false;
						break;
					case ($(input).attr('id') == 'LTATestFormState'):
						if(!valid_states.includes($(input).val()))
						{
							$(input).addClass('error');
							$('div[data-input='+$(input).attr('id')+'][data-type=invalid]').removeClass('hide');
						}
						else
						{
							$(input).attr('data-status', 'valid');
						}
						return false;
						break;
					case ($(input).attr('id') == 'LTATestFormEmail'):
						var reg = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/;
						if (!reg.test($(input).val()))
						{
							if(!silent)
							{
								$(input).addClass('error');
								$('div[data-input='+$(input).attr('id')+'][data-type=invalid]').removeClass('hide');
							}
							$(input).attr('data-status', 'invalid');
						}
						else
						{
							$(input).attr('data-status', 'valid');
						}
						return false;
						break;
					case ($(input).attr('id') == 'LTATestFormDOB_edit'):
                      $('#LTATestFormDOB').attr('data-status', 'valid');
                      if(isValidDate($(input).val())) {
                        var datearray = $(input).val().split("/");
                        var newdate =  datearray[2]+'-'+datearray[0]+'-'+datearray[1];
                        if(validateInput($('#LTATestFormDOB').val(newdate)))
                        {
                          $(input).removeClass('error');
                          $(input).attr('data-status', 'valid');
                        }
                      } else {
                        $(input).addClass('error');
                        $(input).attr('data-status', 'invalid');
                        $('#LTATestFormDOB').addClass('error');
                        $('#LTATestFormDOB').attr('data-status', 'invalid');
                        $('div[data-input="LTATestFormDOB"][data-type=invalid]').removeClass('hide');
                      }
                      break;
					case ($(input).attr('id') == 'LTATestFormDOB'):
						var dob =  new Date($(input).val());
						if(!calculateAge(dob))
						{
							if(!silent)
							{
								$(input).addClass('error');
                                $('#LTATestFormDOB_edit').addClass('error');
								$('div[data-input='+$(input).attr('id')+'][data-type=unacceptable]').removeClass('hide');
							}
							$(input).attr('data-status', 'invalid');
                            $('#LTATestFormDOB_edit').attr('data-status', 'invalid');
							return false;
						}
						else
						{
							$(input).attr('data-status', 'valid');
       						$('#LTATestFormDOB_edit').removeClass('error');
                            $('#LTATestFormDOB_edit').attr('data-status', 'valid');
							return true;
						}
						break;
					default:
						$(input).attr('data-status', 'valid');
						return true;
						break;
				}
			}
		}
	}
  
	var timer = setInterval(function()
	{
		if(typeof Shopify === 'object')
		{
			clearInterval(timer);
			if(typeof $ !== 'function')
			{
				loadScript('//code.jquery.com/jquery-3.4.1.min.js', preLoad);
			}
			else
			{
				preLoad();
			}      
			console.log('HIPAA Compliant PHI Integration by wecre8websites https://www.wecre8websites.com/');
		}
	}, 100);
})();
